$('.ctm-thumbnail').on('click keypress', function(e) {
  if (e.type === 'keypress' && e.which !== 13) return;

  let url = $(this).data('video-url');
  let embedUrl = '';

  // YouTube
  let ytMatch = url.match(/(?:youtube\.com\/(?:watch\?v=|embed\/)|youtu\.be\/)([a-zA-Z0-9_-]{11})/);
  if (ytMatch) {
    embedUrl = 'https://www.youtube.com/embed/' + ytMatch[1] + '?autoplay=1';
  }

  // Vimeo
  let vimeoMatch = url.match(/vimeo\.com\/(\d+)/);
  if (vimeoMatch) {
    embedUrl = 'https://player.vimeo.com/video/' + vimeoMatch[1] + '?autoplay=1';
  }

  if (!embedUrl) return;

  let iframe = $('<iframe>', {
    src: embedUrl,
    frameborder: 0,
    allow: 'autoplay; fullscreen; picture-in-picture',
    allowfullscreen: true,
    class: 'ctm-iframe',
  });

  $(this).replaceWith(iframe);
});
